import { MIN_ARCHIVE_YEAR } from "@/constants/archive";
import type { ArchiveSearchParams, PartialArchiveSearchParams } from "@/types";
import getCurrentYearAndMonth from "./getCurrentYearAndMonth";

const parsePositiveInt = (value: string | null | undefined) => {
  if (!value) {
    return undefined;
  }

  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed <= 0) {
    return undefined;
  }

  return parsed;
};

const isYearInArchiveRange = (year: number, currentYear: number) =>
  year >= MIN_ARCHIVE_YEAR && year <= currentYear;

const getResolvedArchiveSearchParams = (
  params: PartialArchiveSearchParams,
): ArchiveSearchParams => {
  const { currentYear, currentMonth } = getCurrentYearAndMonth();
  const defaultMonth = currentMonth + 1;

  const year = parsePositiveInt(params.year) ?? currentYear;
  const month = parsePositiveInt(params.month) ?? defaultMonth;
  const pageNumber = parsePositiveInt(params.pageNumber) ?? 1;

  const resolvedYear = isYearInArchiveRange(year, currentYear)
    ? year
    : currentYear;
  const resolvedMonth = month >= 1 && month <= 12 ? month : defaultMonth;
  const resolvedPageNumber = pageNumber >= 1 ? pageNumber : 1;

  return {
    year: String(resolvedYear),
    month: String(resolvedMonth),
    pageNumber: String(resolvedPageNumber),
  };
};

export default getResolvedArchiveSearchParams;
